import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  errors: string;
  driver: boolean = false;
  form;

  constructor(private auth: AuthService, private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[A-Z0-9a-z._%±]+@([A-Za-z0-9-]+.)+[A-Za-z]{2,4}$')]],
    });
  }

  forgot() {
    if (this.form.valid) {
      this.auth.forgotMail(this.form.value);
    }
  }
}
